import { useSelector } from 'react-redux';
import { MediaState } from '../../models/media/media.model';
import { RootState } from '../../models/_root-state.model';

export const useMedia = (): MediaState => useSelector((state: RootState) => state.mediaBranch);
